import React, { useState, useEffect, Fragment } from 'react';
import services from '../../services';
import MessageModal from '../../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../../Common';
import { makeStyles } from '@material-ui/core/styles';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import { CommonDecryptParam } from '../../../../../utils/CommonParams';

import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import _ from 'lodash';

import { useHistory } from 'react-router';
import { CommonEncryptParam } from '../../../../../utils/CommonParams';
import { generateStatus } from '../../satusGenerator';
import BackupIcon from '@material-ui/icons/Backup';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ClearIcon from '@material-ui/icons/Clear';

const screenCode = 'PURCHASEORDER';

export function WeighmentVerification(props) {

    let history = useHistory();
    const [orderDetails, setOrderDetails] = useState([]);
    const [itemDetails, setItemDetails] = useState([]);
    const [isClicked, setIsClicked] = useState(false);
    const [weighmentVerification, setWeighmentVerification] = useState({
        groupID: '0',
        operationEntityID: '0',
        orderID: '0',
        collectionTypeID: '0',
        customerID: '0',
        supplierOrderItemsID:'0',
        rejectReason:"",
        modifiedBy:'0'
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const [openDialog, setOpenDialog] = React.useState(false);
    const [supplierWeighmnet, setSupplierWeighmnet] = useState([]);

    const encriptedText = props.match.params["id"];
    const id = (encriptedText !== undefined) ? CommonDecryptParam(encriptedText) : 0;
    const data = id > 0 ? true : false;
    const edit = id > 0 ? true : false;

    const useRowStyles = makeStyles({
        root: {
            '& > *': {
                borderBottom: 'unset',
            },
        },
    });
    const tableHeaderStyle = {
        color: "#263238",
        textTransform: "uppercase",
        fontSize: "12px",
        fontWeight: "bold"
    }
    const subTableHeaders = {
        textTransform: "uppercase",
        fontSize: "12px"
    }

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, []);

    useEffect(() => {
        if (messageModel.hidden === false) {
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true });
            }, 2000);
        }
    }, [messageModel])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDWEIGNMENTVERIFY');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        if (data && edit) {
            trackPromise(
                setScreenData()
            )
        }
    }

    async function setScreenData() {
        var result = await services.getOrderDetailsForWeighmentVerifyScreen(id);
        setOrderDetails(result.order);
        setSupplierWeighmnet(result.supplierWeighnmentSum);

        var copyOfsupplierWeighnmentSum = _.cloneDeep(result.supplierWeighnmentSum);
        var weighmentByItemOrder = [];

        copyOfsupplierWeighnmentSum.forEach(x => {
            var result = weighmentByItemOrder.find(y => y.orderItemID === x.orderItemID);

            if (result) {
                result.supplingQauntity += x.supplingQauntity;
            } else {
                weighmentByItemOrder.push(x);
            }

        });

        var items = [];
        var isOrderItemCompleted = 0;

        result.orderItems.forEach(x => {
            var supplierItems = [];

            var weighmentSupplierOrder = weighmentByItemOrder.find(y => y.orderItemID === x.orderItemID); 

            result.supplierOrderItems.forEach(r => {

                if (r.orderItemID === x.orderItemID) {
                    supplierItems.push({
                        supplierOrderItemsID: r.supplierOrderItemsID,
                        orderItemID: r.orderItemID,
                        customerID: r.customerID,
                        supplierName: r.firstName,
                        unitPrice: r.unitPrice,
                        totalPrice: r.totalPrice,
                        supplingQauntity: r.supplingQauntity,
                        statusTypeID: r.statusTypeID,
                        remark: r.remark
                    })
                }
            })

            items.push(
                createData(
                    x.orderItemID,
                    x.collectionTypeName,
                    x.collectionTypeID,
                    x.itemQuantity,
                    x.measuringUnit,
                    x.state,
                    x.remQty.toFixed(2),
                    weighmentSupplierOrder === undefined ? 0 : weighmentSupplierOrder.supplingQauntity,
                    supplierItems
                )
            );

            if (supplierItems.length > 0)
                    isOrderItemCompleted += 1;

        });

        if (isOrderItemCompleted <= 0) {
            afterSuccessfulyChanged("Success");
            return;
        }

        setItemDetails(items);

        setWeighmentVerification({
            ...weighmentVerification,
            groupID: result.order.groupID,
            operationEntityID: result.order.operationEntityID,
            orderID: result.order.orderID
        });
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/PurchaseAdvice' })
            }, 1500);
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setWeighmentVerification({
            ...weighmentVerification,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntity,
            orderNumber: '',
            buyerID: '0',
            invoiceDate: new Date().toISOString().split('T')[0],
            dueDate: new Date().toISOString().split('T')[0],
            collectionTypeID: '0',
            itemQuantity: '',
            measuringUnit: ''
        })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    async function onConfirmClick(e) {
        e.preventDefault();
        setIsClicked(true);

        var remQtyCount = 0;

        itemDetails.forEach(x => {
            if(x.remQty > 0)
                remQtyCount ++;
        })

        if (remQtyCount > 0) {
            setMessageModel({ ...messageModel, hidden: false, type: "Error", disciption: "Order items quantity is not full filled." });
            setIsClicked(false);
            return;
        }

        var result = checkHasSupplierItems();

        if (result) {
            const response = await services.OrderConfirm(weighmentVerification.orderID, itemDetails);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
            afterSuccessfulyChanged(response.statusCode);
        } else {
            setMessageModel({ ...messageModel, hidden: false, type: "ERORR", disciption: "No supplier order items." });
        }

        setIsClicked(false);
    }

    function checkHasSupplierItems() {
        var totCount = 0;

        itemDetails.forEach(x => {
            x.supplierItems.forEach(y => {
                totCount = totCount + 1;
            });
        });

        if (totCount > 0) {
            return true;
        } else {
            return false;
        }
    }

    async function viewSupplierItemDetails(rowData, itemData) {
        history.push({
            pathname: 'viewWieghment/' + CommonEncryptParam(itemData.supplierOrderItemsID.toString()),
            data: id
        })
       
    }
   

    async function rejectSupplierOrder(rowData, itemData) {
        let data = {
            supplierOrderItemsID: parseInt(itemData.supplierOrderItemsID),
            rejectReason: "Rejected By Web User",
            modifiedBy: parseInt(tokenService.getUserIDFromToken())
        };
        const rejectedData = await services.rejectSupplierOrder(data);
        console.log("Status",rejectedData.statusCode)

        if (rejectedData != null) {
            if (rejectedData.statusCode != null || rejectedData != undefined) {
              if (rejectedData.statusCode == "Success") {
                setMessageModel({
                    ...messageModel,
                    hidden: false,
                    type: "Success",
                    disciption: rejectedData.message,
                  });
                  setTimeout(() => {
                    modalDismissHandler();
                  }, 1500);
                } else {
                setMessageModel({
                    ...messageModel,
                    hidden: false,
                    type: "Error",
                    disciption: rejectedData.message,
                  });
                  setTimeout(() => {
                    modalDismissHandler();
                  }, 1500);
              }
              setScreenData();
            }
          }
            }
   

    async function approveOrderItem(rowData) {
        // if (rowData.remQty > 0) {
        //     setMessageModel({ ...messageModel, hidden: false, type: "Error", disciption: "Order items quantity is not full filled." });
        //     return;
        // }
       // let  totalPrice = totalCal(rowData);

       var supplierArry = [];
       rowData.supplierItems.forEach(r => {

       
            supplierArry.push({
                supplierOrderItemsID: r.supplierOrderItemsID,
                orderItemID: r.orderItemID,
                customerID: r.customerID,
                supplierName: r.supplierName,
                unitPrice: r.unitPrice,
                totalPrice: r.totalPrice,
                supplingQauntity: r.supplingQauntity,
                statusTypeID: r.statusTypeID,
                remark: r.remark,
                weighmentQty : getSupplierWeighmnet(r,rowData),
            })
        
    })
      

        var model = {
            orderItemID: rowData.orderItemID,
            modifiedBy: parseInt(tokenService.getUserIDFromToken()),
            collectionTypeName:rowData.collectionTypeName,
            itemQuantity:rowData.itemQuantity,
            measuringUnit:rowData.measuringUnit,
             orderItemMobileQty:rowData.orderItemMobileQty,
             remQty: parseFloat( rowData.remQty),
             groupID:weighmentVerification.groupID,
             operationEntityID:weighmentVerification.operationEntityID,
             orderNumber:orderDetails.orderNumber,
             totalPrice : totalCalValue(rowData),
             supplierCompletions:supplierArry
        }



        

        const response = await services.OrderItemComplete(model);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });

        if (response.statusCode === "Success")
            setScreenData();
    }

    function createData(orderItemID, collectionTypeName, collectionTypeID, itemQuantity,
        measuringUnit, state, remQty, orderItemMobileQty, supplierItems) {
        return {
            orderItemID,
            collectionTypeName,
            collectionTypeID,
            itemQuantity,
            measuringUnit,
            state,
            remQty,
            orderItemMobileQty,
            supplierItems
        };
    }

    function roundNumber(num) {
        return (Math.round(num * 100) / 100).toFixed(2);
    }

    function totalCal(row) {
        var tot = 0;

        row.supplierItems.forEach(s => {
            if (row.orderItemID === s.orderItemID) {
                tot = tot + parseFloat(s.totalPrice);
            }
        });

        return (
            <div>{roundNumber(parseFloat(tot))}</div>
        )
    }

    function totalCalValue(row) {
        var tot = 0;

        row.supplierItems.forEach(s => {
            if (row.orderItemID === s.orderItemID) {
                tot = tot + parseFloat(s.totalPrice);
            }
        });

       return tot;
    }

    function getSupplierWeighmnet(itemData, row) {
        var result = supplierWeighmnet.find(x => x.supplierOrderItemsID === itemData.supplierOrderItemsID);

        return result === undefined ? 0 : result.supplingQauntity;
    }
    async function UploadManuelSupplierItemDetails(rowData, itemData) {
        var res = await services.uploadManualCompletion(itemData.supplierOrderItemsID);
        setMessageModel({ ...messageModel, hidden: false, type: res.statusCode, disciption: res.message });
     }

    function Row(props) {
        const { row } = props;
        const [open, setOpen] = React.useState(true);
        const classes = useRowStyles();

        return (
            <React.Fragment>
                <TableRow className={classes.root}>
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row">
                        {row.collectionTypeName}
                    </TableCell>
                    <TableCell align="right">{row.itemQuantity}</TableCell>
                    <TableCell align="right">{row.remQty}</TableCell>
                    <TableCell align="right">{roundNumber((row.itemQuantity - row.remQty) - row.orderItemMobileQty)}</TableCell>
                    <TableCell align="right">{totalCal(row)}</TableCell>
                    <TableCell align="right" component="th" scope="row">
                        {row.measuringUnit === 1 ? "Kg" : "Unit"}
                    </TableCell>
                    <TableCell align="right">
                        <input
                            onClick={() => approveOrderItem(row)}
                            type="button"
                            className="btn btn-primary"
                            value="Complete"
                        />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0, backgroundColor: "#FAFAFA" }} colSpan={8}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            {row.supplierItems.length !== 0 ? <Box marginLeft={20}>
                                <Typography variant="body2" gutterBottom component="div">
                                    Supplier Details
                                </Typography>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={subTableHeaders}><b>Supplier</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Quantity</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Unit Price</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Total price (LKR.)</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Weighment Qunatity</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Remark</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Status</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Action</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Upload</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Reject</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.supplierItems.map((itemData, i) => {
                                            return (
                                                <TableRow key={i}>
                                                    <TableCell component="th" scope="row">
                                                        {itemData.supplierName}
                                                    </TableCell>
                                                    <TableCell align="right">{itemData.supplingQauntity}</TableCell>
                                                    <TableCell align="right">{roundNumber(itemData.unitPrice)}</TableCell>
                                                    <TableCell align="right">{roundNumber(itemData.totalPrice)}</TableCell>
                                                    <TableCell align="right">
                                                        {
                                                            getSupplierWeighmnet(itemData, row)
                                                        }
                                                    </TableCell>
                                                    <TableCell align="right">{itemData.remark ? itemData.remark : "-"  }</TableCell>
                                                    <TableCell align="right">
                                                        {
                                                            generateStatus(itemData.statusTypeID)
                                                        }
                                                    </TableCell>
                                                    {/* <TableCell align="right">
                                                        <i
                                                            style={{ cursor: "pointer" }}
                                                            className="fas fa-eye"
                                                            onClick={() => viewSupplierItemDetails(row, itemData)}
                                                        ></i>
                                                    </TableCell> */}
                                                     <TableCell align="right">                                                                             
                                                         <IconButton onClick={() => viewSupplierItemDetails(row, itemData)} color="primary" aria-label="upload picture" component="span">
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell align="right" >
                                                       
                                                        <IconButton disabled={generateStatus(itemData.statusTypeID) != 'Complete'} onClick={() =>  trackPromise(UploadManuelSupplierItemDetails(row, itemData))} color="primary" aria-label="upload picture" component="span">
                                                            <BackupIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell align="right">                                                                             
                                                         <IconButton onClick={() => rejectSupplierOrder(row, itemData)} color="primary" aria-label="edit" component="span">
                                                            <ClearIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </Box> : <p style={{ fontSize: "14px" }}>No Data.</p>}
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Add Weighment Verification"
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/PurchaseAdvice"
                        />
                        <hr />
                        <form onSubmit={(e) => onConfirmClick(e)}>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col"><p style={{ fontSize: "14px" }}>
                                        <b>Order Number: </b> {orderDetails.orderNumber}</p>
                                    </div>
                                    <div className="col"><p style={{ fontSize: "14px", textAlign: "center" }}>
                                        <b>Date: </b>{new Date().toISOString().split('T')[0]}</p>
                                    </div>
                                    <div className="col"><p style={{ fontSize: "14px", float: "right" }}>
                                        <b>Buyer: </b>{orderDetails.buyerName}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <TableContainer component={Paper}>
                                            <Table aria-label="collapsible table">
                                                <TableHead style={{ backgroundColor: "White" }}>
                                                    <TableRow>
                                                        <TableCell />
                                                        <TableCell style={tableHeaderStyle}>Item Name</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Quantity</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Remaining Quantity</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Weighment Rem. Quantity</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Total Price (LKR.)</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Measuring Unit</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Action</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {itemDetails.map((row, i) => {
                                                        return (
                                                            row.supplierItems.length === 0 ? null : <Row key={i} row={row} />
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <input
                                    disabled={isClicked}
                                    type="submit"
                                    className="btn btn-primary pull-right"
                                    value="Complete All"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />

        </Fragment >
    );
}
